import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// import _ from 'lodash'
import cn from 'classnames';
import './ShopDiscoverTabs.scss';

const ShopDiscoverTabs = props => {
  const { featured } = props;
  const { shopSectionLabels } = featured;
  return (
    <div className='shop-discover-tabs-outer-container'>
      <div className='shop-discover-tabs-inner-container'>
        <div className='tabs'>
          <div onClick={() => props.setActiveSection(null)} className={cn('tab', { active: !props.activeSection })}>
            All
          </div>
          {shopSectionLabels.map(label => {
            const isActive = label === props.activeSection;
            const click = () => props.setActiveSection(label);
            return (
              <div key={label} className={cn('tab', { active: isActive })} onClick={click}>
                {label}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

ShopDiscoverTabs.propTypes = {
  featured: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  const { featured } = state;
  return { featured };
};

export default connect(mapStateToProps, {
  // functions go here
})(ShopDiscoverTabs);
